import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import { Chip, Typography, Paper, Box, Divider } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
export default function DataTableData() {
  const AppService = useAppServices()
  const [categories, setCategories] = useState([])
  const [checklists, setChecklists] = useState([])
  const [paths, setPaths] = useState([])
  const [loader, setLoader] = useState(true)
  const navigate = useNavigate()
  const { page_id } = useParams()
  const getCategories = async () => {
    const { response } = await AppService.checklistcategory.get({
      toaster: false,
    })
    if (response) {
      setCategories(response.data)
    } else {
      setCategories([])
    }
  }
  const getToolTip = async () => {
    const { response } = await AppService.tooltip.get({
      toaster: false,
    })
    if (response) {

      setPaths(response.pages)
    } else {
      setPaths([])
    }
  }

  const getChecklists = async () => {
    const { response } = await AppService.checklist.filter({
      toaster: false,
    })
    if (response) {
      setChecklists(response.data)
    } else {
      setChecklists([])
    }
  }

  const onLoad = async () => {
    setLoader(true)
    await Promise.all([getCategories(), getChecklists(), getToolTip()])
    setLoader(false)
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.checklistcategory.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(() => {
    onLoad()
  }, [])

  const checklistsByCategory = categories?.map(category => {
    const categoryChecklists = checklists.filter(
      checklist => checklist?.category === category?._id
    )

    return {
      ...category,
      checklists: categoryChecklists
    }
  })

  return {
    loader: loader,
    paths: paths,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Category', accessor: 'category' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'Status', accessor: 'status' },
        { Header: 'Checklists', accessor: 'checklists' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: checklistsByCategory.map((category) => ({
        category: category.name,
        type: category.type,
        status: category.status,
        checklists: (
          <Box sx={{ width: '100%', minWidth: '300px' }}>
            <Paper
              elevation={1}
              sx={{
                width: '130%',
                p: 2,
                borderRadius: '8px',
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              {category?.checklists?.length > 0 ? (
                <Box sx={{ width: '100%' }}>
                  {category?.checklists?.map((checklist, index) => (
                    <Box key={checklist?._id}>
                      <Chip
                        label={checklist?.name}
                        variant="outlined"
                        sx={{
                          width: '100%',
                          height: 40,
                          borderRadius: 1,
                          justifyContent: 'flex-start',
                          fontSize: '0.875rem',
                          '& .MuiChip-label': {
                            overflow: 'visible',
                            whiteSpace: 'nowrap'
                          },
                        }}
                      />
                      {index < category?.checklists?.length - 1 && (
                        <Divider sx={{
                          my: 1,
                          borderColor: '#000000',
                          borderBottomWidth: 10,
                          opacity: 1
                        }} />
                      )}
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography variant="outlined">
                  No checklist items available
                </Typography>
              )}
            </Paper>
          </Box>
        ),
        action: (
          <MDBox sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <EditModal data={category} handleRefresh={onLoad} paths={paths} />
            <MDButton
              variant="gradient"
              color="warning"
              sx={{ marginLeft: 2 }}
              onClick={() => navigate(`./${category._id}/${category?.type}`, { state: category })}
            >
              view
            </MDButton>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(category?._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}